import { injectable, interfaces } from 'inversify';
import { action, IObservableArray, makeObservable, observable } from 'mobx';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../../../models/paginationInfo.model';
import { currentTimeZone } from '../../../../models/timeZones/timeZones.model';
import { IProjectToolStatisticsDto, IStatisticsListItem, IToolStatisticsDto, ToolStatisticsViewMode } from './projectDetailsStatistics.model';

export interface IProjectDetailsStatisticsStore {
  statistics: IObservableArray<IStatisticsListItem>;
  statisticsPaging: IPagingInfoWithOrder;
  statisticsLoading: boolean;
  selectedTimeZone: { label: string; value: number };
  offset?: number;
  statisticsGeneratedOn?: Date;

  toolStatistics: IProjectToolStatisticsDto;
  selectedToolStatistics?: IToolStatisticsDto;
  toolStatisticsViewMode: ToolStatisticsViewMode;
  resetStatisticsOrdering(): void;
}

export namespace IProjectDetailsStatisticsStore {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsStatisticsStore> = Symbol('PROJECT_DETAILS_STATISTICS_STORE');
}

@injectable()
export class ProjectDetailsStatisticsStore implements IProjectDetailsStatisticsStore {
  statistics: IObservableArray<IStatisticsListItem> = observable.array([]);

  statisticsPaging: IPagingInfoWithOrder = {
    ...PaginationInfoDefault,
    orderBy: 'date',
    orderType: 'desc',
  };

  statisticsLoading: boolean = false;

  selectedTimeZone: { label: string; value: number } = currentTimeZone || { label: 'UTC ± 00:00', value: 0 };

  offset?: number = undefined;

  statisticsGeneratedOn?: Date = undefined;

  toolStatistics: IProjectToolStatisticsDto = {
    projectId: '',
    generatedAt: '',
    headers: { annotationToolsHeaders: [], annotationQuestionHeaders: [], imageSetsHeaders: [], isUpToDate: true },
    annotationTypesStatistics: [],
    questionStatistics: [],
    allAnnotationTypeStatistics: [],
    allQuestionsStatistics: [],
    imageSetsStatistics: [],
    allImageSetsStatistics: [],
  };

  selectedToolStatistics?: IToolStatisticsDto = undefined;

  toolsSelectedAnnotationType = '';

  toolsSelectedQuestion = '';

  toolStatisticsViewMode = ToolStatisticsViewMode.NONE;

  constructor() {
    makeObservable(this, {
      statistics: observable,
      statisticsPaging: observable,
      statisticsLoading: observable,
      selectedTimeZone: observable,
      offset: observable,
      statisticsGeneratedOn: observable,
      toolStatistics: observable,
      selectedToolStatistics: observable,
      toolsSelectedAnnotationType: observable,
      toolsSelectedQuestion: observable,
      toolStatisticsViewMode: observable,
      resetStatisticsOrdering: action,
    });
  }

  resetStatisticsOrdering(): void {
    this.statisticsPaging.orderBy = 'date';
    this.statisticsPaging.orderType = 'desc';
  }
}
